import {
    BasketAddonModel,
    BasketItemModel,
    BasketCareKitAddonModel,
    ProductTypes,
    UpsellModel,
    UpsellTypes,
    BasketDetailsModel,
    LEATHER_CARE_KIT_TYPE,
    FABRIC_CARE_KIT_TYPE,
    SOFASHIELD
} from 'models/Basket';

const CARE_KIT_PRICE_FOR_TWO = 60;

export class UpsellsHelper {
    public getAvailableUpsells(basket: BasketDetailsModel, careKitsAddons: BasketCareKitAddonModel[], sofashieldAddons: BasketAddonModel[]): UpsellModel[] {
        if (basket.hasDwellProducts()) {
            return [];
        }

        let availableUpsells: UpsellModel[] = [];

        let isEirePostcode = basket.isCurrentPostcodeEire();
        let sofashieldAddon = sofashieldAddons.find(a => a.name === SOFASHIELD);
        if (sofashieldAddon?.isRecommended) {
            availableUpsells.push({
                type: UpsellTypes.Sofashield,
                options: [{
                    quantity: 1,
                    price: null,
                    code: sofashieldAddon.code
                }],
                isDisabled: isEirePostcode
            });
        }

        let careKitLeatherAddon = careKitsAddons.find(carekit => carekit?.isRecommended && carekit.materials.some(material => material === LEATHER_CARE_KIT_TYPE));
        if (careKitLeatherAddon) {
            availableUpsells.push({
                type: UpsellTypes.LeatherCareKit,
                options: [{
                    quantity: 1,
                    price: careKitLeatherAddon.price.value
                },
                {
                    quantity: 2,
                    price: CARE_KIT_PRICE_FOR_TWO
                }],
                isDisabled: false
            });
        }

        let careKitFabricAddon = careKitsAddons.find(carekit => carekit?.isRecommended && carekit.materials.some(material => material === FABRIC_CARE_KIT_TYPE));
        if (careKitFabricAddon) {
            availableUpsells.push({
                type: UpsellTypes.FabricCareKit,
                options: [{
                    quantity: 1,
                    price: careKitFabricAddon.price.value
                },
                {
                    quantity: 2,
                    price: CARE_KIT_PRICE_FOR_TWO
                }],
                isDisabled: false
            });
        }

        if (this.shouldIncludeSofaglide(basket.entries)) {
            availableUpsells.push({
                type: UpsellTypes.Sofaglide,
                options: [{
                    quantity: 1,
                    price: null
                }],
                isDisabled: false
            });
        }

        if (this.shouldIncludeSofaRescue(basket.entries)) {
            availableUpsells.push({
                type: UpsellTypes.SofaRescue,
                options: [{
                    quantity: 1,
                    price: null
                }],
                isDisabled: false
            });
        }

        return availableUpsells;
    }

    private shouldIncludeSofaglide(basketEntries: BasketItemModel[]): boolean {
        return basketEntries.some(item => {
            if (item.product.type !== ProductTypes.DefaultProduct) {
                return false;
            }

            let hasAvailableSofaglides = Boolean(item.availableSofaglides?.length);
            let hasCorrectLinkedSofaglide = Boolean(item.linkedSofaglide?.quantity === item.quantity);

            return hasAvailableSofaglides && !hasCorrectLinkedSofaglide;
        });
    }

    private shouldIncludeSofaRescue(basketEntries: BasketItemModel[]): boolean {
        return false;
    }
}

export const upsellsHelper = new UpsellsHelper();